import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { motion } from 'framer-motion';
import { Play, Dumbbell } from 'lucide-react';

export const ProgramSidebar = ({ program, availableWorkouts, stats, programId }) => {
  const totalWorkouts = program.weeks?.reduce((acc, w) => {
    const dayCount = w.days ? Object.values(w.days).filter(Boolean).length : 0;
    const legacyCount = !w.days && w.workouts ? w.workouts.length : 0;
    return acc + dayCount + legacyCount;
  }, 0) || 0;

  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="bg-card border border-border p-6">
        <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">Program Stats</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Duration</span>
            <span className="text-white font-heading">{program.duration_weeks} weeks</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Purchases</span>
            <span className="text-green-400 font-heading">{stats.purchases}</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Enrollments</span>
            <span className="text-blue-400 font-heading">{stats.enrollments}</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Total Workouts</span>
            <span className="text-primary font-heading">{totalWorkouts}</span>
          </div>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.1 }} className="bg-card border border-border p-6">
        <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">Quick Actions</h3>
        <div className="space-y-3">
          <Link to={`/program/${programId}`} target="_blank">
            <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
              <Play className="h-4 w-4 mr-2" /> Preview Program
            </Button>
          </Link>
          <Link to="/admin?tab=workouts">
            <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
              <Dumbbell className="h-4 w-4 mr-2" /> Manage Workouts
            </Button>
          </Link>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 }} className="bg-card border border-border p-6">
        <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">
          <Dumbbell className="inline h-5 w-5 mr-2 text-primary" />
          Available Workouts
        </h3>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {availableWorkouts.map((workout) => (
            <div key={workout.id} className="flex items-center justify-between p-2 bg-black border border-border text-sm">
              <span className="text-white">{workout.title}</span>
              <Badge className="bg-primary/20 text-primary text-xs">{workout.category}</Badge>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
